import styled from "styled-components";
import { black } from "../../utils/color";


export const StyledP = styled.p`
    font-size: 14px;
    color: ${(props)=>props.color?props.color:black}
`
